import PremiumTrialCTA from './components/PremiumTrialCTA';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionSection from './components/SolutionSection';
import BulkMessagingSection from './components/BulkMessagingSection';
import AutomationSection from './components/AutomationSection';
import IndustrySolutions from './components/IndustrySolutions';
import FeatureShowcase from './components/FeatureShowcase';
import StatsSection from './components/StatsSection';
import WorkflowSection from './components/WorkflowSection';
import WhyDigiFlow from './components/WhyDigiFlow';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import OfficesSection from './components/OfficesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ScrollButtons from './components/ScrollButtons';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <PremiumTrialCTA />
        <HeroSection />
        <ProblemsSection />
        <SolutionSection />
        <BulkMessagingSection />
        <AutomationSection />
        <IndustrySolutions />
        <FeatureShowcase />
        <StatsSection />
        <WorkflowSection />
        <WhyDigiFlow />
        <PricingSection />
        <FAQSection />
        <OfficesSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ScrollButtons />
    </div>
  );
}